import Layout from '../../layout/index'

const publicWelfareRouter = {
  path: '/publicwelfare',
  component: Layout,
  redirect: '/publicwelfare/index',
  children: [
    {
      path: 'index',
      name: 'publicWelfare',
      component: () => import('../../views/publicwelfare/index')
    }
  ]
}
export default publicWelfareRouter
